import * as actions from '../actions/toba';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import { push,goBack } from 'connected-react-router'

export function replaceUrlTobaIdAfterPopulatingTobaFormFromRevision(sources) {
    const action$ = sources.ACTION
        .filter(action => action.type === ActionTypes.POPULATE_TOBA_FORM_FROM_REVISION)
        .map(action => push('/solicitors/tobas/' + action.payload.tobaRevision.id));

    return {
        ACTION: action$,
    };
}

export function requestTobaRevisionById(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_TOBA_REVISION_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/toba/toba/' + action.payload.tobaId,
            category: 'requestTobaRevisionById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestTobaRevisionById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getTobaRevisionByIdSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestTobaRevisionByIdFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestTobaRevisionById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getTobaRevisionByIdFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestUpdateToba(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UPDATE_TOBA)
        .map(action => ({
            url: BASE_URL + 'api/toba/toba/' + action.payload.tobaId,
            category: 'requestUpdateToba',
            method: 'PATCH',
            type: 'application/json',
            send: action.payload.sendBody,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.updateTobaSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateTobaFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateToba')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.updateTobaFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestTobaRevisionsAfterReceivingToba(sources) {
	const action$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_TOBA_BY_ID)
        .map(action => actions.getTobaRevisions({initialRevision: action.payload.body.initialRevision}) );

    return {
        ACTION: action$,
    };
}

export function requestTobaRevisions(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_TOBA_REVISIONS)
        .map(action => ({
            url: BASE_URL + 'api/toba/initialRevision/' + action.payload.initialRevision,
            category: 'requestTobaRevisions',
            method: 'GET',
            type: 'application/json',
            send: action.payload,
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestTobaRevisions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getTobaRevisionsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestTobaRevisionsFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestTobaRevisions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getTobaRevisionsFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function postNewToba(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_POST_NEW_TOBA)
		.map(action => ({
			url: BASE_URL + 'api/toba/Toba',
			category: 'newToba',
			method: 'POST',
			type: 'application/json',
			send: action.payload,
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('newToba')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => actions.receivePostNewTobaResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badResponsePostNewToba(sources) {
	let httpResponse$ = sources.HTTP
		.select('newToba')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 201)
		.map(response => actions.receiveBadResponsePostNewToba(response));

	return {
		ACTION: httpResponse$
	};
}



export function getTobaMessage(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_TOBA_MESSAGE)
		.map(action => ({
			url: BASE_URL + 'api/toba/message' ,
			category: 'tobaMessage',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('tobaMessage')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveTobaMessage(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedTobaMessage(sources) {
	let httpResponse$ = sources.HTTP
		.select('tobaMessage')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveFailureTobaMessage(response));

	return {
		ACTION: httpResponse$
	}
}